import { Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { Resources } from './resources';
import { updateRoutes } from '@shared/utils/route.utils';
import { LayoutComponent } from './layouts/layout.component';
import universalBillingRouting from '@modules/universal-billing/universal-billing.routing';
import errorsRouting from '@modules/errors/errors.routing';
import privacyPolicyRoute from '@modules/privacy-policy/privacy-policy.routing';
import settingsRouting from '@modules/settings/settings.routing';
import { AuthGuard } from '@app/auth/auth.guard';
import smartControllerRouting from "@modules/smart-controller/smart-controller.routing";
import buildingPlanRouting from "@modules/building-plan/building-plan.routing";
import termsOfUseRouting from '@modules/terms-of-use/terms-of-use.routing';
import {AuthForgotPasswordComponent} from '@app/auth/auth-pages/auth-forgot-password/auth-forgot-password.component';
import {ResetPasswordComponent} from '@app/auth/auth-pages/reset-password/reset-password.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: updateRoutes([
      {
        path: Resources.Dashboard,
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(c => c.DashboardComponent),
      },
      settingsRouting,
      ...universalBillingRouting,
      smartControllerRouting,
      buildingPlanRouting,
      {
        path: '',
        redirectTo: Resources.Dashboard,
        pathMatch: 'full',
      }
    ] as Routes)
  },
  {
    path: Resources.InvoicePayment,
    loadComponent : () => import('./modules/invoice-payment/invoice-payment.component').then(c=> c.InvoicePaymentComponent),
  },
  {
    path: 'auth',
    component: AuthComponent,
    loadChildren: () => import('./auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: 'auth/forgot-password',
    component: AuthForgotPasswordComponent
  },
  {
    path: `password/reset/:token`,
    component: ResetPasswordComponent
  },
  privacyPolicyRoute,
  termsOfUseRouting,
  errorsRouting,
  {path: '**', redirectTo: 'error/404'}
];
